// Copyright (c) Microsoft. All rights reserved.

import { FC } from 'react';
import { useChat } from '../../../libs/hooks/useChat_v2';
import { Button } from '../../../components/Button';
import { useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';

export const ChatSet: FC = () => {
  const chat = useChat();
  // const [isDesktop, setIsDesktop] = useState(!checkMobileKate() || window.innerWidth <= 768);

  // useEffect(() => {
  //   setIsDesktop(window.innerWidth > 768);
  // }, []);

  const  isDesktop  = useAppSelector((state:RootState) => state.app.viewType == 'Desktop');

  const openPopUp = () => {
    const options =
      'location=no,menubar=no,toolbar=yes,scrollbars=no,resizable=yes,width=1600,height=800,left=200,top=200';

    window.open('/makers/agent', '_blank', options);
  };

  return (
    <>
      {isDesktop && (
        <div className="chat-services">
          {/* <Button control icon="chat" onClick={() => {}}>
            AI 톡비서
          </Button> */}
          <Button
            control
            icon="spark"
            onClick={() => {
              openPopUp();
            }}
          >
            AI Makers
          </Button>
        </div>
      )}
      <div className="chat-set">
        <Button
          classOnly="chat-button"
          onClick={() => {
            chat.createChatRoom(false);
          }}
        >
          새로운 채팅
        </Button>
      </div>
    </>
  );
};
